import type { CycleData, PeriodData } from "@qendo/profile";
import Data from "~/util/data";

const DEFAULT_CYCLE_LENGTH = 28;
const DEFAULT_PERIOD_LENGTH = 7;

export class CurrentCycleData extends Data implements CycleData {
    public constructor(
        public cycle: number = DEFAULT_CYCLE_LENGTH,
        public period: number = DEFAULT_PERIOD_LENGTH,
        public tracked: boolean = false,
        public estimate: boolean = false,
        public estimated_cycle: number | null = null,
        public estimated_period: number | null = null,
        public periods: PeriodData[] = [],
    ) {
        super();
    }
}
